"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DependentViewport = exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _resizeObserverPolyfill = _interopRequireDefault(require("resize-observer-polyfill"));

var _terraBreakpoints = _interopRequireWildcard(require("terra-breakpoints"));

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};

          if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }

    newObj.default = obj;
    return newObj;
  }
}

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

var DependentViewport = {
  WINDOW: 'window',
  PARENT: 'parent'
};
exports.DependentViewport = DependentViewport;
var propTypes = {
  /**
   * Child nodes.
   */
  children: _propTypes.default.node,

  /**
   * A callback function invoked when the breakpoint size changes. onChange(<string>breakpoint)
   */
  onChange: _propTypes.default.func,

  /**
   * A callback function invoked when the responsive target resizes. onResize(<number>width)
   */
  onResize: _propTypes.default.func,

  /**
   * An element to be displayed at tiny breakpoints.
   */
  tiny: _propTypes.default.element,

  /**
   * An element to be displayed at small breakpoints.
   */
  small: _propTypes.default.element,

  /**
   * An element to be displayed at medium breakpoints.
   */
  medium: _propTypes.default.element,

  /**
   * An element to be displayed at large breakpoints.
   */
  large: _propTypes.default.element,

  /**
   * An element to be displayed at huge breakpoints.
   */
  huge: _propTypes.default.element,

  /**
   * An element to be displayed at enormous breakpoints.
   */
  enormous: _propTypes.default.element,

  /**
   * The viewport the element will be responsive to. One of `window` or `parent`.
   */
  responsiveTo: _propTypes.default.oneOf(['window', 'parent'])
};
var defaultProps = {
  responsiveTo: 'parent'
};

var ResponsiveElement =
/*#__PURE__*/
function (_React$Component) {
  _inherits(ResponsiveElement, _React$Component);

  function ResponsiveElement() {
    var _this;

    _classCallCheck(this, ResponsiveElement);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ResponsiveElement).call(this));
    _this.state = {
      element: null
    };
    _this.setContainer = _this.setContainer.bind(_assertThisInitialized(_this));
    _this.handleResize = _this.handleResize.bind(_assertThisInitialized(_this));
    _this.handleWindowResize = _this.handleWindowResize.bind(_assertThisInitialized(_this));
    _this.animationFrameID = null;
    return _this;
  }

  _createClass(ResponsiveElement, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      if (this.container) {
        this.resizeObserver = new _resizeObserverPolyfill.default(function (entries) {
          _this2.animationFrameID = window.requestAnimationFrame(function () {
            _this2.animationFrameID = null;

            _this2.handleResize(entries[0].target.getBoundingClientRect().width);
          });
        });
        this.resizeObserver.observe(this.container);
      } else {
        this.handleResize(window.innerWidth);
        window.addEventListener('resize', this.handleWindowResize);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.container) {
        window.cancelAnimationFrame(this.animationFrameID);
        this.resizeObserver.disconnect(this.container);
        this.container = null;
      } else {
        window.removeEventListener('resize', this.handleWindowResize);
      }
    }
  }, {
    key: "setContainer",
    value: function setContainer(node) {
      if (node === null) {
        return;
      } // Ref callbacks happen on mount and unmount, element will be null on unmount


      this.container = this.props.responsiveTo === 'parent' ? node.parentNode : null;
    }
  }, {
    key: "handleResize",
    value: function handleResize(width) {
      var _this$props = this.props,
          onChange = _this$props.onChange,
          onResize = _this$props.onResize,
          tiny = _this$props.tiny,
          small = _this$props.small,
          medium = _this$props.medium,
          large = _this$props.large,
          huge = _this$props.huge,
          enormous = _this$props.enormous;

      if (onResize) {
        onResize(width);
      }

      var activeBreakpoint = (0, _terraBreakpoints.activeBreakpointForSize)(width);

      if (onChange && activeBreakpoint !== this.breakpoint) {
        onChange(activeBreakpoint);
      }

      this.breakpoint = activeBreakpoint; // Only update the state if an uncontrolled component exists.

      if (tiny || small || medium || large || huge || enormous) {
        var element;

        if (width >= _terraBreakpoints.default.enormous && enormous) {
          element = 'enormous';
        } else if (width >= _terraBreakpoints.default.huge && huge) {
          element = 'huge';
        } else if (width >= _terraBreakpoints.default.large && large) {
          element = 'large';
        } else if (width >= _terraBreakpoints.default.medium && medium) {
          element = 'medium';
        } else if (width >= _terraBreakpoints.default.small && small) {
          element = 'small';
        } else {
          element = 'tiny';
        }

        if (this.state.element !== element) {
          this.setState({
            element: element
          });
        }
      }
    }
  }, {
    key: "handleWindowResize",
    value: function handleWindowResize() {
      this.handleResize(window.innerWidth);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          children = _this$props2.children,
          responsiveTo = _this$props2.responsiveTo;

      if (this.state.element) {
        return this.props[this.state.element] || null;
      }

      return _react.default.createElement(_react.default.Fragment, null, responsiveTo === 'parent' && !this.container && _react.default.createElement("div", {
        ref: this.setContainer
      }), children);
    }
  }]);

  return ResponsiveElement;
}(_react.default.Component);

ResponsiveElement.propTypes = propTypes;
ResponsiveElement.defaultProps = defaultProps;
var _default = ResponsiveElement;
exports.default = _default;